import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification } from 'antd'
import { history } from '../sagas'
import * as graphql from '../../services/graphql'
import actions from './actions'

export function* LOGIN({ payload }) {
  const { email, password, rememberMe } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true
    }
  })
  const success = yield call(graphql.login, email, password, rememberMe)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT'
    })
    yield history.push('/')
    notification.success({
      message: 'Logged In',
      description: 'You have successfully logged in!'
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false
      }
    })
    notification.error({
      message: 'Could not login',
      description: 'Please check your email and password.'
    })
  }
}

export function* FORGOT_PASSWORD({ payload }) {
  const { email } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true
    }
  })
  const success = yield call(graphql.forgotPassword, email)
  if (success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false
      }
    })
    notification.success({
      message: 'Email sent',
      description: 'Check your inbox to reset your password.'
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false
      }
    })
    notification.error({
      message: 'Could not reset your passwod',
      description: 'Please check your email and try again.'
    })
  }
}

export function* RESET_PASSWORD({ payload }) {
  const { token, password, passwordConfirmation } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true
    }
  })
  const success = yield call(graphql.resetPassword, token, password, passwordConfirmation)
  if (success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false
      }
    })
    yield history.push('/auth/login')
    notification.success({
      message: 'Password reset',
      description: 'Your password was successfully reset.'
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false
      }
    })
    notification.error({
      message: 'Could not reset your passwod',
      description: 'Please try again later.'
    })
  }
}

export function* REGISTER({ payload }) {
  const { email, password, name, passwordConfirmation } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true
    }
  })
  const success = yield call(graphql.register, email, password, passwordConfirmation, name)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT'
    })
    yield history.push('/')
    notification.success({
      message: 'Succesful Registered',
      description: 'You have successfully registered!'
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false
      }
    })
    yield put({
      type: 'user/LOGOUT'
    })
    notification.error({
      message: 'Could not register',
      description: 'Please check your entered values.'
    })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true
    }
  })
  const response = yield call(graphql.currentUser)
  if (response) {
    const { id, email, name, avatar, isAreaManager, superadmin } = response
    yield put({
      type: 'user/SET_STATE',
      payload: {
        id,
        name,
        email,
        avatar,
        isAreaManager,
        superadmin,
        authorized: true
      }
    })
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false
    }
  })
}

export function* LOGOUT() {
  yield call(graphql.logout)
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false
    }
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.FORGOT_PASSWORD, FORGOT_PASSWORD),
    takeEvery(actions.RESET_PASSWORD, RESET_PASSWORD),
    takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    LOAD_CURRENT_ACCOUNT() // run once on app load to check user auth
  ])
}
